import styles from "./RefundPage.module.scss";
import {cn} from "@/utils/cn.ts";
import {QualityRefund} from "@/pages/Refund/components/QualityRefund.tsx";
import {NotRefundProduct} from "@/pages/Refund/components/NotRefundProduct.tsx";
import {NotQualityRefund} from "@/pages/Refund/components/NotQualityRefund.tsx";

/**
 * Страница возврата товара
 * @returns {JSX.Element}
 */
export const RefundPage = () => {
    return (
        <div className={cn("refund-block", styles.container)}>
            <h4>Как вернуть товар</h4>
            <div className={styles.mb}>
                Обмен или возврат товаров, приобретённого в сервисе подбора автотоваров Подзамену, осуществляется в соответствии с действующим законодательством России —
                <a className="primary-color" href="https://www.consultant.ru/document/cons_doc_LAW_305/" target="_blank">Законом РФ от 07.02.1992 № 2300–1 «О защите прав потребителей»</a> и <a className="primary-color" href="https://www.consultant.ru/document/cons_doc_LAW_373622/" target="_blank">Постановлением Правительства РФ от 31.12.2020 N 2463 «Об утверждении Правил продажи товаров по договору розничной купли-продажи...»</a>.
            </div>
            <QualityRefund/>
            <NotRefundProduct/>
            <NotQualityRefund/>
        </div>
    );
};
